// src/datadog.js
import { datadogRum } from "@datadog/browser-rum";
import { environmentConstants } from "utils/constants";

const { production, staging } = environmentConstants;
let isProd = process.env.REACT_APP_ENV === production.value;

// Function to initialize Datadog RUM
export const initDatadog = () => {
  // Initialize Datadog RUM
  datadogRum.init({
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
    site: "us5.datadoghq.com",
    service: process.env.REACT_APP_DATADOG_SERVICE,
    env: isProd ? production.name : staging.name,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,

    // Only collect errors
    trackInteractions: false,
    trackResources: false,
    trackLongTasks: false,
    trackErrors: false,

    defaultPrivacyLevel: "mask-user-input"
  });
  datadogRum.startSessionReplayRecording();
};
